/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter } from "../../shared";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { ForecastSourcesControl } from "./controls/ForecastSourcesControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { useDescription } from "./hooks/useDescription";
import { SLIDE_NUMBER } from "./constants";

export default function Slide31(props: { exportMode?: boolean }) {
  const { exportMode } = props;
  const [commodity] = useParameter<number>("@commodities");
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const description = useDescription();

  useExportQuery(title, subtitle);
  const { isFavouriteLoading } = useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup isLoading={isFavouriteLoading}>
          <CommoditiesControl />
          <ForecastSourcesControl key={commodity || undefined} />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart-historical" />
          <ReportRenderer componentId="chart-forecast" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
